import { Autocomplete, Box, TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { type Country } from 'services'

interface CountryAddressSelectorProps {
  countries: Country[]
  value: Country | null
  setValue: (country: Country | null) => void
  disabled: boolean
}

export const CountryAddressSelector: React.FC<CountryAddressSelectorProps> = ({ countries, value, setValue, disabled }) => {
  useEffect(() => {
    if (value?.id != null && value.country_desc == null) {
      const foundCountry = countries.find((country) => country.id === value.id)
      if (foundCountry != null) {
        value.country_desc = foundCountry.country_desc
        setValue(value)
      }
    }
  }, [value, countries, setValue])

  return (<Autocomplete
        id="country-select-demo"
        options={countries}
        getOptionLabel={(option) => option?.country_desc ?? ''}
        renderOption={(props, option) => (
            <Box component="li" {...props}>
                {option.country_desc}
            </Box>
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={value}
        onChange={(event, value) => {
          setValue(value)
        }}
        disabled={disabled}
        renderInput={(params) => (
            <TextField
                {...params}
                label="Country"
                inputProps={{
                  ...params.inputProps
                }}
            />
        )}
    />)
}
